import { buildCampCode } from './share/shortLink';

/**
 * Resolves the value `CampaignDetailPage` seeds into
 * `useCampaignUiStore.campaignShortCode`: prefer the campaign's stored,
 * collision-adjusted `short_code`; fall back to the client-derived
 * `buildCampCode(slug)` for legacy campaigns that never had one stored — the
 * exact same fallback `useCampaignShare.ts`'s `makeShortUrl` already uses for
 * the share-link builders (`campCode = campaignShortCode || buildCampCode(...)`).
 *
 * Keeping this pure and standalone (rather than inline in the page's effect)
 * makes it unit-testable without mounting the whole page component, and lets
 * `pendingPublicActionRegistry.ts`'s I1 campCode check rely on
 * `campaignShortCode` never being empty for any campaign that could ever have
 * minted a `campCode` — see that file's module doc comment.
 */
export function resolveCampaignShortCode(shortCode: string | undefined, slug: string): string {
  return shortCode || buildCampCode(slug);
}
